module.exports = __webpack_public_path__ + "img/17@3x.640f1b15.png";